import React, { useEffect, Fragment, useState } from "react"
import { Button, Col, Container, Jumbotron, Row, Spinner } from "react-bootstrap"
import NavBarUser from "./../../components/shared/NavBarUser"
import { withRouter, Link } from "react-router-dom"
import { getResultadosVotacion, getInforme } from "./../../services/user.service"
import ShowResultados from "../../components/tricel/ShowResultados"
import { toast } from "react-toastify"
import Loader from "../../components/shared/Loader"

const Resultados = ({ location, history }) => {
	const { votacion } = location
	const [resultados, setResultados] = useState({})
	const [loader, setLoader] = useState()
	const [showButton, setShowButton] = useState(false)

	const getInformePdf = async () => {
		setLoader(true)
		toast.info("Generando archivo...")
		const response = await getInforme(votacion.id)
		console.log(response)
		if (response?.status === 200) {
			const url = window.URL.createObjectURL(new Blob([response.data]))
			const link = document.createElement("a")
			link.href = url
			link.setAttribute("download", `Resultados_${votacion.nombre}_${Date.now()}.pdf`)
			document.body.appendChild(link)
			link.click()
		}
		setLoader(false)
	}

	const getData = async () => {
		setLoader(true)
		const res = await getResultadosVotacion(votacion.id)
		console.log(res)
		if (res?.response === "success") {
			setResultados(res.data)
		} else {
			toast.error(res?.message || "Se produjo un error al cargar resultados")
		}
		setLoader(false)
		setShowButton(true)
	}

	useEffect(() => {
		console.log(votacion)
		if (votacion) {
			getData()
		}
	}, [votacion])

	return (
		<Fragment>
			<NavBarUser />
			<Container className="mt-4">
				<Jumbotron>
					<h1>Elección: {votacion.nombre}</h1>
					<h4>Unidad: {votacion.unidad.nombre}</h4>
					<p>{votacion.descripcion}</p>
					<hr />
					<div className="text-center mb-4">
						<h2>Resultados</h2>
						A continuación, se presenta el cómputo total neto de cada uno de las y los candidatos de su proceso de elecciones.
						Considere que son el total por cada elección, señalando igualmente las opciones de votos Nulos y Blancos.
						El resultado final de cada elección depende del reglamento de cada departamento. Puede generar un reporte del
						recuento de votos en el botón bajo el cuadro del cómputo.
					</div>
					{Object.keys(resultados).length === 0 ? null : ( // <Loader />
						<ShowResultados resultados={resultados} isClosed={votacion.estado === "cerrado"} />
					)}

					<Row className="justify-content-center mt-5">
						{votacion.estado === "abierto" && (
							<Col lg={2}>
								<Button onClick={getData} disabled={loader} className="w-100 btn-lg">
									{loader ? (
										<Fragment>
											Actualizando &nbsp;
											<Spinner
												as="span"
												animation="border"
												size="sm"
												role="status"
												aria-hidden="true"
											/>
										</Fragment>
									) : (
										"Actualizar"
									)}
								</Button>
							</Col>
						)}
					</Row>
					<br />
					<hr />
					{loader &&  <Loader/>}
					{!loader && (
						<Fragment>
							<Row className="justify-content-center">
								{votacion.estado === "cerrado" && (
									<Col lg={3}>
										<Button variant="info" block onClick={getInformePdf}>
											Generar PDF
										</Button>
									</Col>
								)}
							</Row>
							<Row className="justify-content-center my-4">
								<Col lg={3}>
									<Button variant="secondary" block onClick={() => history.goBack()}>
										Volver
									</Button>
								</Col>
							</Row>
						</Fragment>
					)}
				</Jumbotron>
			</Container>
		</Fragment>
	)
}

export default withRouter(Resultados)
